// The three blog categories this site uses. They are fixed: each one is a page
// (/research, /cases, /events) that lists the CMS blogs filed under it. A blog
// whose CMS category is none of these is not shown anywhere on the site.

export const BLOG_CATEGORIES = {
  research: {
    key: "research",
    name: "Research",
    href: "/research",
    eyebrow: "Publications & Studies",
    subtitle: "Research articles, studies and academic work from the department",
    emptyText: "No research articles have been published yet.",
    aliases: ["research"],
  },
  cases: {
    key: "cases",
    name: "Cases",
    href: "/cases",
    eyebrow: "Clinical Cases",
    subtitle: "Case discussions and clinical learnings from the department",
    emptyText: "No cases have been published yet.",
    aliases: ["cases", "case"],
  },
  events: {
    key: "events",
    name: "Events",
    href: "/events",
    eyebrow: "Academic Events",
    subtitle: "Conferences, workshops and activities from the department",
    emptyText: "No events have been published yet.",
    aliases: ["events", "event"],
  },
};

export const BLOG_CATEGORY_LIST = Object.values(BLOG_CATEGORIES);

const normalise = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const CATEGORY_BY_ALIAS = {};
BLOG_CATEGORY_LIST.forEach((category) =>
  category.aliases.forEach((alias) => {
    CATEGORY_BY_ALIAS[alias] = category;
  })
);

// Returns the site category of a blog from the CMS, or null. It is the blog's
// CMS `category`, matched by slug first and by name second. A blog with no
// category, or one outside the three above, belongs to no page.
export function getCategoryForPost(post) {
  const category = post?.category;
  if (!category) return null;
  if (typeof category === "string") return CATEGORY_BY_ALIAS[normalise(category)] || null;
  return CATEGORY_BY_ALIAS[normalise(category.slug)] || CATEGORY_BY_ALIAS[normalise(category.name)] || null;
}

// The page a blog is served from: /<category>/<slug>. Only categorised blogs
// have one.
export function getBlogPath(post) {
  const category = getCategoryForPost(post);
  return category ? `${category.href}/${post.display_url}` : null;
}
